import { IconName, UI_ICONS_MAPPING } from '@src/components/base'
import { UiIcon } from '@src/types'

export const getNotificationIconName = (icon?: UiIcon | null): IconName | undefined => {
  if (!icon) {
    return undefined
  }

  return UI_ICONS_MAPPING[icon]
}
